import type { TableElement } from '@/components/canvas/document/publicTypes';

export function getMergedRangeContaining(
  element: TableElement,
  r: number,
  c: number,
): [number, number, number, number] | null {
  const ranges = element.data.mergedRanges ?? [];
  for (const range of ranges) {
    const [r0, c0, r1, c1] = range;
    if (r >= r0 && r <= r1 && c >= c0 && c <= c1) return range;
  }
  return null;
}
